<template>
  <section>
    <div class="section_title">
      <img src="@/assets/img/cart_sub.jpg" />
      <h1 class="">ご注文</h1>
    </div>
    <h2 class="mb-0 mt-2 text-left">3.お支払い方法の選択</h2>
    <div class="form-navi my-5">
      <ul class="d-flex flex-wrap">
        <li class="px-3">1.カートを確認</li>
        <li class="px-3">2.お届け先の選択</li>
        <li class="here px-3">3.お支払い方法の選択</li>
        <li class="px-3">4.最終確認</li>
      </ul>
    </div>
    <section>
      <div class="detail-cart box-p-20 mb-5 border">
        <h2 class="mb-3 text-left">お支払方法</h2>
        <dl class="c-radio">
          <dt>
            <input
              id="daibiki"
              type="radio"
              name="payment"
              v-model="paymentMethod"
              value="0"
            />
            <label for="daibiki"><strong>代金引換</strong></label>
          </dt>
          <dd>
            ※代金引換の場合には別途代金引換手数料として<span>{{
              collectFee
            }}</span
            >円が商品代金に加算されます
          </dd>
        </dl>
        <dl class="c-radio my-4" v-if = "!shopping">
          <dt>
            <input
              id="furikomi"
              type="radio"
              name="payment"
              v-model="paymentMethod"
              value="1"
            />
            <label for="furikomi"><strong>銀行振込</strong></label>
          </dt>
          <dd>
            ※商品出荷は入金確認後となりますので、ご希望のお届け指定日の発送が難しい場合があります。
          </dd>
        </dl>
        <dl v-show="!orderProxy" class="c-radio borders">
          <dt id="dtCredit">
            <input
              id="credit"
              type="radio"
              name="payment"
              v-model="paymentMethod"
              value="3"
            />
            <label for="credit"><strong>クレジットカード</strong></label>
          </dt>
          <dd id="ddCredit">
            ※クレジットカード決済の場合は、カード会社サイトで決済のための入力が必要になります。<br />
            <img
              id="Visa"
              class="mr-2 mt-2"
              src="@/assets/img/visa.gif"
              alt="visa"
            />
            <img
              id="Master"
              class="mr-2 mt-2"
              src="@/assets/img/master.png"
              alt="master"
            />
            <img
              id="JCB"
              class="mr-2 mt-2"
              src="@/assets/img/jcb.gif"
              alt="jcb"
            />
            <img id="AE" class="mr-2 mt-2" src="@/assets/img/ae.gif" alt="ae" />
            <img
              id="Diners"
              class="mr-2 mt-2"
              src="@/assets/img/diners.gif"
              alt="diners"
            />
          </dd>
        </dl>
        <dl v-show="paymentCash" class="c-radio">
          <dt>
            <input
              v-model="paymentMethod"
              type="radio"
              name="payment"
              id="cash"
              value="2"
            /><label for="cash"><strong>現金</strong></label>
          </dt>
        </dl>
        <dl class="c-radio">
          <dt>
            <input
              id="atobarai"
              type="radio"
              name="payment"
              v-model="paymentMethod"
              value="5"
            />
            <label for="atobarai"><strong>後払い</strong></label>
          </dt>
          <dd>
            <div style="font-size: smaller; margin-left: 10px;">
              ※後払い手数料：0円<br>
              &nbsp;&nbsp;&nbsp;当サービスは(株)キャッチボールが運営します。下記注意事項を確認、同意の上ご利用ください。<br>
              <br>
              【注意事項】<br>
              &nbsp;&nbsp;&nbsp;(株)キャッチボールから請求書が送られます。請求書記載の期限内にお支払いいただけない場合などは、<br>
              &nbsp;&nbsp;&nbsp;再度の請求毎に390円(税込)の再請求手数料がかかります。<br>
              &nbsp;&nbsp;&nbsp;商品の配送先を配送業者の営業所止め（営業所来店引取り）、転送依頼することはできません。<br>
              &nbsp;&nbsp;&nbsp;ご利用者が未成年の場合、法定代理人の利用同意を得てください。<br>
              &nbsp;&nbsp;&nbsp;（株）キャッチボールは、<a href="https://www.catch-ball.jp/privacy/" target="_blank" rel="noreferrer noopener">プライバシーポリシー</a>に応じて個人情報および注文内容を適切に管理いたします。<br>
              &nbsp;&nbsp;&nbsp;その他詳細は、(株)キャッチボールのサービス<a href="https://atobarai-user.jp/omit/atobarai_unaccompanied/" target="_blank" rel="noreferrer noopener">ご利用規約</a>をご確認下さい。<br>
                <img id="AE" class="mr-2 mt-2" src="@/assets/img/atobarai_abp_450x126.jpg" alt="atobarai" />
              </div>
          </dd>
        </dl>
      </div>
    </section>
    <section  v-show="cartItems.length > 0">
      <div class="detail-cart box-p-20 mb-5 border">
        <h2 class="mb-3 text-left">マナビスポイントの使用</h2>
        <table class="table-point w-100 mb-4">
          <tbody>
            <tr>
              <td class="bg_gray">
                使用可能ポイント：{{ PossessionPoint }}ポイント
              </td>
              <td class="d-none">&nbsp;</td>
            </tr>
            <tr>
              <td>
                <input
                  v-model="usePointType"
                  value="1"
                  class="mb-2 mr-3"
                  type="radio"
                  name="point"
                />使用可能なポイントをすべて使用する
              </td>
              <td class="text-right">
                <input
                  type="text"
                  v-model="usePoint1"
                  class="mx-2 text-right"
                  disabled
                />ポイント
              </td>
            </tr>
            <tr>
              <td>
                <input
                  v-model="usePointType"
                  value="2"
                  class="mb-2 mr-3"
                  type="radio"
                  name="point"
                />一部のポイントを使用する
              </td>
              <td class="text-right">
                使用ポイント数<input
                  v-model="usePoint2"
                  type="text"
                  class="mx-2 text-right"
                  v-bind:disabled="usePointType != '2'"
                />ポイント
              </td>
            </tr>
            <tr>
              <td>
                <input
                  v-model="usePointType"
                  value="0"
                  class="mb-2 mr-3"
                  type="radio"
                  name="point"
                />ポイントを使用しない
              </td>
              <td class="d-none">&nbsp;</td>
            </tr>
          </tbody>
        </table>
        <ul class="list-dot-01">
          <li>ポイントは、１ポイントから使用できます。</li>
          <li>
            一部のポイントを使用する場合は、使用ポイントを入力してください。
          </li>
          <li>
            ポイントは、商品およびツール品に使用できます。<br class="only_pc">
            送料および代金引換手数料に使用できませんのでご注意ください。
          </li>
          <li>
            商品およびツール品代金の全額をポイントでお買い物をしてお支払金額がない場合、<br>
            支払方法は適用されませんのでご注意ください。
          </li>
        </ul>
      </div>
    </section>
    <section v-show="cartItems.length > 0">
      <div class="detail-cart border box-p-20">
        <h2 class="mb-3 text-left">ご購入金額明細</h2>
        <div class="d-flex py-3 border-bottom only_pc">
          <div class="shohin_group text-center"><p>商品</p></div>
          <div class="shohin_quantity text-center"><p>個数</p></div>
          <div class="shohin_price text-center"><p>価格</p></div>
        </div>
        <!-- 動的HTML生成部 カート商品 -->
        <div id="CartList">
          <ul>
            <li
              v-for="(item, i) in cartItems"
              :key="item.no"
              class="d-flex align-items-center border-bottom"
            >
              <div class="shohin_group d-flex align-items-center my-3">
                <p>{{ i + 1 }}</p>
                <img
                  :src="imgHome + item.no + '/thumb.jpg'"
                  :alt="item.name"
                  @error="noImage"
                  class="mx-4"
                />
                <p>{{ item.name }}</p>
              </div>
              <div class="shohin_quantity text-center my-3">
                {{ item.count }}個
              </div>
              <div class="shohin_price my-3">
                <p class="text-right">{{ item.amount }}円</p>
              </div>
            </li>
          </ul>
        </div>
        <div>
          <div class="d-flex my-3">
            <div class="shohin_price_all text-right"><p>小計</p></div>
            <div class="shohin_price text-right">
              <p>{{ totalItems.subTotal }}円</p>
            </div>
          </div>

          <div v-if="paymentMethod === '0'" class="style-d-flex my-3">
            <div class="shohin_price_all text-right"><p>代金引換手数料</p></div>
            <div class="shohin_price text-right">
              <p>{{ totalItems.collectFee }}円</p>
            </div>
          </div>

          <div class="d-flex my-3">
            <div class="shohin_price_all text-right"><p>送料</p></div>
            <div class="shohin_price text-right">
              <p>{{ totalItems.carriageFee }}円</p>
            </div>
          </div>
          <div class="d-flex my-3">
            <div class="shohin_price_all text-right"><p>使用ポイント</p></div>
            <div class="shohin_price text-right">
              <p>{{ usePoint }}ポイント</p>
            </div>
          </div>
          <div class="d-flex my-3">
            <div class="shohin_price_all text-right"><p>合計</p></div>
            <div class="shohin_price text-right">
              <p>{{ total }}円</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="d-flex justify-content-around text-center column_sp">
      <div>
        <router-link
          to="/cart/delivery"
          id="GoBackShippingAddress"
          class="btn d-inline-block mt-5"
          >お届け先の選択へ戻る</router-link
        >
      </div>
      <div v-show="paymentMethod !== ''">
        <button @click="confirm" class="btn d-inline-block my-5">
          最終確認へ進む
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import Request from "@/modules/Request";
import Store from "@/modules/Store";
import Message from "@/modules/Message";

let request = new Request();
let store = new Store();
import Authenticate from "@/modules/Authenticate";
let auth = new Authenticate();

export default {
  data() {
    return {
      collectFee: 0,
      paymentMethod: "",
      paymentCash: "",
      orderProxy: "",
      cartItems: [],
      totalItems: {},
      imgHome: process.env.VUE_APP_CONTENTS_PRODUCT_HOME,
      PossessionPoint: 0,
      usePoint: 0,
      usePoint1: 0,
      usePoint2: 0,
      usePoint2tmp: 0,
      usePointType: 0,
      subTotal: 0,
      total: 0,
      isProxy: false,
      canUsePoint: 0,
      shopping: true,
      collectFee_default: 0,
    };
  },
  mounted() {
    window.scroll(0, 0);
    this.shopping = auth.getShopping();
    this.getPaymentMethod();
    if (store.get("PossessionPoint") != "") {
      this.PossessionPoint = store.get("PossessionPoint");
    }
    if (store.get("isProxy") == "1") {
      this.isProxy = true;
    }
  },
  watch: {
    paymentMethod: function () {
      // 初回ロード時にセッション値が設定された場合
      // 任意に値を変更した場合
      // カート内容と小計等を更新する
      this.loadCart();
    },
    usePoint: function () {
      var tmpPoint = this.usePoint;
      if (tmpPoint == "") {tmpPoint=0;}
      if (this.paymentMethod == "0" && 
          parseInt(this.totalItems.subTotal.replace(",", "")) - 
          parseInt(tmpPoint) <= 0) {
            
            this.total = this.totalItems.carriageFee;
            this.totalItems.collectFee = 0;
            
        } else {

            this.totalItems.collectFee = this.collectFee_default;
            this.total =
              parseInt(this.totalItems.total.replace(",", "")) -
              parseInt(tmpPoint);

        } 
      this.total = this.total.toLocaleString();
    },
    usePoint2: function () {
      if (this.usePointType == "2") {
        if (!this.usePointCheck()) return;
        this.usePoint2tmp = this.usePoint2;
        this.usePoint = this.usePoint2;
      }
    },
    usePointType: function () {
      switch (this.usePointType) {
        case "0":
          this.usePoint1 = 0;
          this.usePoint2 = 0;
          this.usePoint = 0;
          break;
        case "1":
          if (parseInt(this.PossessionPoint) <= 0) {
            Message.error()
              .fire({
                title: "保有ポイントが0のためポイント使用はできません",
              })
              .then(() => {
                this.usePointType = "0";
              });
            return false;
          }
          if (parseInt(this.subTotal) < parseInt(this.PossessionPoint)) {
            this.usePoint1 = this.subTotal;
          } else {
            this.usePoint1 = this.PossessionPoint;
          }
          this.usePoint = this.usePoint1;
          this.usePoint2 = 0;
          break;
        case "2":
          if (parseInt(this.PossessionPoint) <= 0) {
            Message.error()
              .fire({
                title: "保有ポイントが0のためポイント使用はできません",
              })
              .then(() => {
                this.usePointType = "0";
              });
            return false;
          }
          this.usePoint1 = 0;
          this.usePoint = this.usePoint2;
          break;
      }
    },
  },
  methods: {
    noImage(event) {
      event.target.src =
        process.env.VUE_APP_CONTENTS_PRODUCT_HOME + "/nothumb.jpg";
    },
    getPaymentMethod() {
      let postParams = [];
      let requestParams = request.createParams(
        "webMdlOrder",
        "getPaymentMethod",
        postParams
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.collectFee = data.CollectFee;
          this.paymentMethod = data.PaymentMethod;
          this.paymentCash = data.PaymentCash;
          this.orderProxy = data.OrderProxy;

          // PaymentMethodをwatch対象にし、変更と共にカート内容をロードする
        });
    },
    loadCart() {
      let postParams = [this.paymentMethod];
      let requestParams = request.createParams(
        "webMdlOrder",
        "getPaymentMethodDetail",
        postParams
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.cartItems = data.cartItems;
          this.totalItems = data.totalItems;
          this.collectFee_default = this.totalItems.collectFee;
          this.total = data.totalItems.total;
          this.subTotal = data.totalItems.subTotal.replace(",", "");

          var tmpPoint = this.usePoint;
          if (tmpPoint == "") {tmpPoint=0;}
          if (this.paymentMethod == "0" && 
              parseInt(this.totalItems.subTotal.replace(",", "")) - 
              parseInt(tmpPoint) <= 0) {
                
                this.total = this.totalItems.carriageFee;
                this.totalItems.collectFee = 0;
                
            } else {

                this.totalItems.collectFee = this.collectFee_default;
                this.total =
                  parseInt(this.totalItems.total.replace(",", "")) -
                  parseInt(tmpPoint);

            } 
          this.total = this.total.toLocaleString();
        });
    },
    confirm() {
      if (!this.usePointCheck(true)) return false;
      store.set("usePoint", this.usePoint.toString());
      this.$router.push("/cart/confirm");
    },
    usePointCheck(isConfirm = false) {
      if (parseInt(this.PossessionPoint) > parseInt(this.subTotal)) {
        this.canUsePoint = this.subTotal;
      } else {
        this.canUsePoint = this.PossessionPoint;
      }
      if (this.usePointType == 1 && parseInt(this.usePoint1) < 1) {
        Message.error()
          .fire({
            title:
              "保有ポイントは" +
              this.PossessionPoint +
              "です。1～" +
              this.canUsePoint +
              "以内で再度入力して下さい",
          })
          .then(() => {
            this.usePoint2 = 0;
          });
        return false;
      }
      if (
        this.usePointType == 2 &&
        (this.usePoint2 == "" || parseInt(this.usePoint2) < 1) &&
        isConfirm
      ) {
        Message.error()
          .fire({
            title: "使用ポイントが入力されていません",
          })
          .then(() => {
            this.usePoint2 = 0;
          });
        return false;
      }
      if(this.usePointType == 0 && isConfirm){
        return true;
      }
      if (parseInt(this.usePoint2) > parseInt(this.subTotal)) {
        Message.error()
          .fire({
            title:
              "保有ポイントは" +
              this.PossessionPoint +
              "です。1～" +
              this.canUsePoint +
              "以内で再度入力して下さい",
          })
          .then(() => {
            this.usePoint2 = 0;
          });
        return false;
      }
      if (parseInt(this.usePoint2) > parseInt(this.PossessionPoint)) {
        Message.error()
          .fire({
            title:
              "保有ポイントは" +
              this.PossessionPoint +
              "です。1～" +
              this.canUsePoint +
              "以内で再度入力して下さい",
          })
          .then(() => {
            this.usePoint2 = 0;
          });
        return false;
      }
      if (parseInt(this.usePoint) > parseInt(this.PossessionPoint)) {
        Message.error()
          .fire({
            title:
              "保有ポイントは" +
              this.PossessionPoint +
              "です。1～" +
              this.canUsePoint +
              "以内で再度入力して下さい",
          })
          .then(() => {
            this.usePoint2 = 0;
          });
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
.table-point td {
  border: 1px solid #dee2e6;
  padding: 10px 15px;
}
.table-point .bg_gray {
  background-color: #f4f4f4;
}
@media (max-width: 768px) {
  .table-point td {
    display: block;
  }
}
</style>